import type { FinisherCertificateTemplate } from '../../../../../../../../graphql/rest-link/types.ts';
import type { SubstitutionMap } from './types.ts';

const SPONSOR_LOGOS_TAG = '%SPONSOR_LOGOS%';

type BuildSponsorLogoSubstitutionsParams = {
  template?: Pick<FinisherCertificateTemplate, 'sponsorLogos' | 'sponsorLogoHeight'> | null;
  content: string;
};

// Quotes would close the src attribute around the image path.
const encodeQuotes = (url: string): string => url.replace(/'/g, '%27').replace(/"/g, '%22');

/**
 * Renders the sponsor logo row the `legacy` base template places under its stats. With no logos
 * the tag is left for the leftover-tag cleanup to blank out.
 */
const buildSponsorLogoSubstitutions = ({
  template,
  content,
}: BuildSponsorLogoSubstitutionsParams): SubstitutionMap => {
  const { sponsorLogos, sponsorLogoHeight } = template ?? {};

  if (!content.includes(SPONSOR_LOGOS_TAG) || !sponsorLogos?.length || !sponsorLogoHeight) {
    return {};
  }

  // Each logo gets an equal share of the row so wide logos cannot push the others off the card.
  const maxWidthPercent = Math.floor(100 / sponsorLogos.length);
  const images = sponsorLogos
    .map(
      ({ imagePath }) =>
        `<img src="${encodeQuotes(imagePath)}" alt="" style="max-height: ${sponsorLogoHeight}px; max-width: ${maxWidthPercent}%; width: auto; height: auto;" />`
    )
    .join('');

  // The tag sits inside a Polotno text element, so the row sets its own height and line height
  // rather than inheriting the text box's.
  return {
    [SPONSOR_LOGOS_TAG]: `<span style="display: flex; align-items: center; justify-content: space-evenly; width: 100%; height: ${sponsorLogoHeight}px; line-height: 0;">${images}</span>`,
  };
};

export default buildSponsorLogoSubstitutions;
